import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';

function HotKeysLabel({ handleOnChange, isChecked }) {
  const t = useTranslation();
  return (
    <div className='cpt-bottom-check-container'>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className='cpt-hotkey-label' onChange={handleOnChange}>
        <input
          type='checkbox'
          className='cpt-kot-keys-small-input'
          checked={isChecked}
          onChange={handleOnChange}
        />
        <span className='cpt-hotkey-lab-select'>
          <i className='icon-check cpt-icon-small-check' />
        </span>
        <span className='cpt-hotkey-lab-text'>{t(TranslationKeys.HotkeyEnabled)}</span>
      </label>
    </div>
  );
}

export default HotKeysLabel;
